import React from "react";
import { Input } from "@progress/kendo-react-inputs";
import "../../../../styles/ExpressionBuilder.css";

/**
 * Disabled input component for standard functions that don't require values
 * @returns {JSX.Element} Disabled input component with notice
 * @author Abhishek Dhillon
 * @parent ValueInput
 */
const DisabledInput = () => {
  return (
    <div>
      <Input
        disabled={true}
        placeholder='No value required for this function'
        className='expression-builder-w-100'
        value=''
        id='value-input-disabled'
      />
      <div className='standard-function-notice'>
        <small className='text-muted'>Standard functions do not require a value</small>
      </div>
    </div>
  );
};

export default DisabledInput;
